var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5625 0 0 2.9375 0 6.5C0 8.0625 0.65625 9.46875 1.78125 10.5938C1.375 12.1875 0.0625 13.5625 0.0625 13.5938C0 13.6562 -0.03125 13.7812 0 13.875C0.0625 13.9688 0.125 14 0.25 14C2.3125 14 3.875 13.0312 4.625 12.4062C5.65625 12.7812 6.78125 13 8 13C12.4062 13 16 10.0938 16 6.5C16 2.9375 12.4062 0 8 0ZM9 8.25C9 8.40625 8.875 8.5 8.75 8.5H4.25C4.09375 8.5 4 8.40625 4 8.25V7.75C4 7.625 4.09375 7.5 4.25 7.5H8.75C8.875 7.5 9 7.625 9 7.75V8.25ZM12 5.25C12 5.40625 11.875 5.5 11.75 5.5H4.25C4.09375 5.5 4 5.40625 4 5.25V4.75C4 4.625 4.09375 4.5 4.25 4.5H11.75C11.875 4.5 12 4.625 12 4.75V5.25Z",
    fill: "#1A86E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.1fd7121c.svg";
export { ForwardRef as ReactComponent };